import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { AppContext } from "../context";
const Movies = () => {
  const { movies, isLoading, error } = useContext(AppContext);
  const showTitle = (title) => {
    let MovieName = title.length > 15 ? `${title.slice(0, 16)} ...` : title;
    return MovieName;
  };
  // console.log("movies are", movies);
  if (error) {
    return <p className="error">{error}</p>;
  }
  return (
    <>
      {!isLoading ? (
        <section className="movie-list">
          {movies.map((movie) => {
            return (
              <NavLink to={`movie/${movie.imdbID}`} key={movie.imdbID}>
                <article className="movie">
                  <h3 className="title">{showTitle(movie.Title)}</h3>
                  <img src={movie.Poster} alt={`${movie.Title} Movie`} />
                </article>
              </NavLink>
            );
          })}
        </section>
      ) : (
        <p className="loading">Loading ....</p>
      )}
    </>
  );
};

export default Movies;
